export default __webpack_public_path__ + "static/media/ADX.0267018d.svg";